export function SectionHeading({ id, title, description }) {
  return (
    <div className="max-w-2xl">
      <h2 id={id} className="text-3xl font-extrabold leading-tight tracking-tight text-balance text-graphite sm:text-4xl">
        {title}
      </h2>
      {description ? <p className="mt-4 text-lg leading-relaxed text-steel">{description}</p> : null}
    </div>
  );
}